import { render } from "./TeamPointsGamesCard.vue?vue&type=template&id=1bcf0972&scoped=true"
import script from "./TeamPointsGamesCard.vue?vue&type=script&lang=js"
export * from "./TeamPointsGamesCard.vue?vue&type=script&lang=js"

import "./TeamPointsGamesCard.vue?vue&type=style&index=0&id=1bcf0972&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bcf0972"]])

export default __exports__